import { render, staticRenderFns } from "./ProductsAdvancedSearch.vue?vue&type=template&id=63c9fbf6&"
import script from "./ProductsAdvancedSearch.vue?vue&type=script&lang=js&"
export * from "./ProductsAdvancedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductsAdvancedSearch.vue"
export default component.exports